import {IEventData} from 'coreClasses/events/IEvents';
import PageViewEventModel from './PageViewEventModel';
import ManagerRepository from 'coreClasses/ManagerRepository';

/**
 * Represents ProductListPageViewEventModel
 */
export default class ProductListPageViewEventModel extends PageViewEventModel {
	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		super(managerRepository, data);

		if (data?.pageSpecificData) {
			for (let specificData in data.pageSpecificData) {
				this[specificData] = data.pageSpecificData[specificData];
			}
		}
	}
};
